import { render, staticRenderFns } from "./RentalAllProducts.vue?vue&type=template&id=47ecd5b8&scoped=true&"
import script from "./RentalAllProducts.vue?vue&type=script&lang=ts&"
export * from "./RentalAllProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ecd5b8",
  null
  
)

export default component.exports